import { useMediaQuery } from "@mui/material";
import { IGift } from "@smartrr/shared/entities/Gift";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { NestedKeyOf, localize, typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import { localizeDefault } from "@smartrr/shared/utils/sharedTranslations/localizeDefault";

import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

export const useMobileQuery = () => {
  return useMediaQuery("(max-width:600px)");
};

export const getGift = (purchaseState: IPurchaseState, skdIdx: number) =>
  (purchaseState.gifts ?? [])
    .map((g: IGift) => ({ ...g, cpsId: purchaseState.id }))
    .find((g: IGift) => g.skdIdx === skdIdx);

export const localizeShorthand = (shorthand: string) => {
  return (suffix: string, params?: { [key: string]: any }) => {
    return localize(`${shorthand}.${suffix}`, params);
  };
};

export const useOrganization = () => {
  const organization = useSmartrrCustomerSelector(state => state.auth.organization);
  return organization!;
};

export function resetScroll() {
  if (typeof document !== "undefined") {
    const mainAdminAppElem = document.querySelector("#smartrr_inner");
    if (mainAdminAppElem) {
      mainAdminAppElem.scrollTop = 0;
    }
  }
}

export const getTranslationValue = (localizeKey: NestedKeyOf<typeof localizeDefault>, value: string) => {
  const separatedProperty = localizeKey.split(".");
  const localizeSection = separatedProperty[0];
  const localizeSectionProperty = separatedProperty[1];

  if (typedLocalize(localizeKey) === localizeDefault[localizeSection][localizeSectionProperty]) {
    return value;
  }
  return typedLocalize(localizeKey);
};
